import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TablePagination from '@material-ui/core/TablePagination'
import Paper from '@material-ui/core/Paper'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { TableHead, TableTitle } from '../../common'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as laundryActions from '../../actions/Laundries'

const ROWS = [
  {
    id: 'date',
    label: Strings.default.DATE,
    numeric: false,
    sortType: 'string'
  },
  {
    id: 'laundryTime.startTime',
    label: Strings.default.TIME,
    numeric: false,
    sortType: 'secondString'
  },
  {
    id: 'laundry.name',
    label: Strings.default.FACILITY,
    numeric: false,
    sortType: 'secondString'
  },
  {
    id: 'user.appartment',
    label: Strings.default.BOOKED_BY,
    numeric: false,
    sortType: 'secondString'
  },
  {
    id: 'user.address',
    label: Strings.default.ADDRESS,
    numeric: false,
    sortType: 'secondString'
  },
  {
    id: 'status',
    label: Strings.default.STATUS,
    numeric: false,
    sortType: 'string'
  }
]

class LaundryBookingsTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    orderBy: 'date',
    order: 'desc',
    sortType: 'string'
  }

  getTime(timeId) {
    const { data } = this.props
    const times = data.laundrySystem.times

    for (let i = 0; i < times.length; i++) {
      if (times[i].id.toString() === timeId.toString()) {
        return times[i].startTime + '-' + times[i].endTime
      }
    }

    return Strings.default.NOT_AVAILABLE
  }

  getName(laundryId) {
    const { data } = this.props
    const laundries = data.laundrySystem.laundries
    const laundryType = data.laundrySystem.laundryRule.laundryType

    for (let i = 0; i < laundries.length; i++) {
      if (laundries[i].id.toString() === laundryId.toString()) {
        return Strings.default.LAUNDRY[laundryType] + ' ' + laundries[i].name
      }
    }

    return Strings.default.NOT_AVAILABLE
  }

  getApartment(apartmentId) {
    const { data } = this.props
    const apartments = data.community.apartments

    for (let i = 0; i < apartments.length; i++) {
      if (apartments[i].id.toString() === apartmentId.toString()) {
        return apartments[i]
      }
    }

    return null
  }

  getApartmentNumber(apartmentId) {
    const apartment = this.getApartment(apartmentId)

    if (apartment) {
      return Strings.default.APARTMENT + " " + apartment.number
    } 

    return Strings.default.NOT_AVAILABLE
  }

  getUserAddress(apartmentId) {
    const apartment = this.getApartment(apartmentId)

    if (apartment) {
      return apartment.address
    } 

    return Strings.default.NOT_AVAILABLE
  }

  getStatus(status) {
    if (status === 'unBooked') {
      return Strings.default.UNBOOKED
    }

    return ''
  }

  desc(a, b, orderBy, sortType) {
    if (sortType === 'integer') {
      return b[orderBy] - a[orderBy]
    }

    if (sortType === 'secondString') {
      const orderArray = orderBy.split('.')
      if (b[orderArray[0]][orderArray[1]] < a[orderArray[0]][orderArray[1]]) {
        return -1
      } else if (
        b[orderArray[0]][orderArray[1]] > a[orderArray[0]][orderArray[1]]
      ) {
        return 1
      }

      return 0
    }

    if (sortType === 'boolean') {
      if (a[orderBy] && !b[orderBy]) {
        return 1
      } else if (!a[orderBy] && b[orderBy]) {
        return -1
      }

      return 0
    }

    if (b[orderBy] < a[orderBy]) {
      return -1
    } else if (b[orderBy] > a[orderBy]) {
      return 1
    }

    return 0
  }

  stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index])

    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0])

      if (order !== 0) {
        return order
      }

      return a[1] - b[1]
    })

    return stabilizedThis.map(el => el[0])
  }

  getSorting(order, orderBy, sortType) {
    return order === 'desc'
      ? (a, b) => this.desc(a, b, orderBy, sortType)
      : (a, b) => -this.desc(a, b, orderBy, sortType)
  }

  render() {
    const { classes, data } = this.props
    const { page, rowsPerPage, orderBy, order, sortType } = this.state
    const startIndex = page * rowsPerPage
    const bookings = data.laundrySystem.bookings

    return (
      <div>
        <Paper className={classes.root}>
          <TableTitle
            classes={classes}
            onIconClick={() => this.props.showCreateLaundryModal()}
            header={Strings.default.BOOKED_LAUNDRY_TIMES}
            addIcon={false}
          />
          <Table className={classes.table} aria-labelledby="tableTitle">
            <TableHead
              rows={ROWS}
              order={order}
              orderBy={orderBy}
              sortOn={(newOrderBy, newOrder, newSortType) =>
                this.setState({
                  orderBy: newOrderBy,
                  order: newOrder,
                  sortType: newSortType
                })
              }
              extraColumn={false}
            />
            <TableBody>
              {this.stableSort(
                bookings,
                this.getSorting(order, orderBy, sortType)
              )
                .slice(startIndex, rowsPerPage + startIndex)
                .map(booking => {
                  return (
                    <TableRow key={booking.id} className={classes.row}>
                      <TableCell>{booking.date}</TableCell>
                      <TableCell>{this.getTime(booking.timeId)}</TableCell>
                      <TableCell>{this.getName(booking.laundryId)}</TableCell>
                      <TableCell>
                        {this.getApartmentNumber(booking.apartmentId)}
                      </TableCell>
                      <TableCell>
                        {this.getUserAddress(booking.apartmentId)}
                      </TableCell>
                      <TableCell>{this.getStatus(booking.status)}</TableCell>
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
          <TablePagination
            component={'div'}
            count={bookings.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            labelRowsPerPage={'Rader per sida:'}
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} av ${count}`
            }
            onChangePage={(event, page) => this.setState({ page })}
            onChangeRowsPerPage={event =>
              this.setState({ rowsPerPage: event.target.value })
            }
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
          />
        </Paper>
      </div>
    )
  }
}

const Styles = {
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa'
    }
  },
  spacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: 'green'
  },
  title: {
    flex: '0 0 auto'
  }
}

LaundryBookingsTable.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data }) {
  return { data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...laundryActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(LaundryBookingsTable)



// WEBPACK FOOTER //
// ./src/components/containers/LaundryBookingsTable/index.js